interface RetryOptions {
    maxAttempts?: number;
    initialDelayMs?: number;
}

export async function retryWithBackoff<T>(
    fn: () => Promise<T>,
    options: RetryOptions = {},
): Promise<T> {
    const { maxAttempts = 5, initialDelayMs = 500 } = options;

    let lastError: unknown;
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
            return await fn();
        } catch (error) {
            lastError = error;
            if (attempt === maxAttempts) break;
            const base = initialDelayMs * Math.pow(2, attempt - 1);
            const jitter = 0.8 + Math.random() * 0.4;
            await new Promise((resolve) => setTimeout(resolve, base * jitter));
        }
    }
    throw lastError;
}
